import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  & > div {
    display: flex;
    align-items: center;
  }

  .MuiTypography-root {
    line-height: 16px !important;
  }

  a {
    color: ${props => props.theme.colors.accent.on};
  }
`

export const RefundQuantity = styled.p`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
  margin-top: ${props => props.theme.spacing.sp16};
  margin-bottom: ${props => props.theme.spacing.sp16};
  color: ${props => (props.negative ? props.theme.colors.danger.onSurface : props.theme.colors.text.default)};
  font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
  font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};

  svg {
    color: ${props => (props.negative ? props.theme.colors.danger.onSurface : props.theme.colors.text.default)};
  }
`

export const RefundTitle = styled.div`
  display: flex;
  justify-content: space-between;
`
